import * as React from 'react';
import { UIHeading2, UIHeading3, useDeviceType } from '@cian/ui-kit';

import { SeoMarkedListItem } from './components';
import * as styles from './SeoMarkedList.css';
import { IMarkedListItem } from '../../types/seoData';

interface ISeoMarkedListProps {
  items: IMarkedListItem[];
}

export const SeoMarkedList: React.FC<ISeoMarkedListProps> = ({ items }) => {
  const isPhone = useDeviceType() === 'phone';
  const Heading = isPhone ? UIHeading3 : UIHeading2;

  return (
    <div className={styles['container']} data-testid="FAQ">
      <div className={styles['heading']}>
        <Heading>Часто задаваемые вопросы</Heading>
      </div>
      {items.map((item, index) => {
        const id = `SeoMarkedListItem_${index}`;

        return <SeoMarkedListItem key={id} id={id} title={item.title} content={item.content} />;
      })}
    </div>
  );
};
